// extracted by mini-css-extract-plugin
export default {"reservateComplete":"_ReservateComplete_reservateComplete__MO-9A","link":"_ReservateComplete_link__DUZgR"};